export const recordStatuses = {
  duplicate: 'duplicate',
  error: 'error',
  failed: 'failed',
  skipped: 'skipped',
  success: 'success',
  updated: 'updated'
};

export const stepIndices = {
  'upload': 1,
  'preview': 2,
  'run': 3,
  'review': 4
};
